import {Fragment} from 'react';

import CSS from './Button.module.scss';
import Focus from './Focus';
import Vector, {type VectorName} from './vector/Vector';

export type ButtonProps = Parameters<typeof Button>[0];

export default function Button({
  children,
  className,
  vectorName,
  isLoading,
  isSelected,
  isAlternate,
  isSecondAlternate,
  isThirdAlternate,
  isSpecial,
  isPositive,
  isAlternatePositive,
  isNegative,
  isAlternateNegative,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  vectorName?: VectorName;
  isLoading?: boolean;
  isSelected?: boolean;
  isAlternate?: boolean;
  isSecondAlternate?: boolean;
  isThirdAlternate?: boolean;
  isSpecial?: boolean;
  isPositive?: boolean;
  isAlternatePositive?: boolean;
  isNegative?: boolean;
  isAlternateNegative?: boolean;
}) {
  const Wrapper = props.disabled ? Fragment : Focus;

  return (
    <Wrapper>
      <button
        type={props.type || 'button'}
        className={[
          CSS.button,
          className || '',
          vectorName ? CSS.icon : '',
          isSelected ? CSS.selected : '',
          isAlternate
            ? CSS.alternate
            : isSecondAlternate
            ? CSS.secondAlternate
            : isThirdAlternate
            ? CSS.thirdAlternate
            : isSpecial
            ? CSS.special
            : isPositive
            ? CSS.positive
            : isAlternatePositive
            ? CSS.alternatePositive
            : isNegative
            ? CSS.negative
            : isAlternateNegative
            ? CSS.alternateNegative
            : ''
        ].join(' ')}
        {...props}>
        {vectorName && (
          <Vector
            className={isLoading ? CSS.loading : undefined}
            name={vectorName}
            svgProps={{size: '1.5rem'}}
          />
        )}
        {children}
      </button>
    </Wrapper>
  );
}
